// src/context.ts
import { createContext } from "@lit/context";

export const renderSpecContext = createContext<string | null>(
  Symbol("renderSpecContext"),
);
